const PolicyHolderData = ({
  Name,
  Document,
}) => ({
  name: Name ?? '',
  document: Document ?? '',
})

export default PolicyHolderData
